module.exports = __webpack_public_path__ + "img/运动装备-2.cd7445e7.png";